<template>
  <div>
    <LibraryIcon class="text-brand-green w-10 h-10 mx-auto mb-5" />
    <h2 class="text-3xl py-3 text-center">Success!</h2>

    <p class="py-5 text-center">You have successfully activated My Payments</p>
    <p class="pb-10">
      Within the next few days you will receive test deposits in your bank account to complete the
      setup of your My Payments account.
    </p>
    <div class="flex py-3">
      <router-link
        tag="div"
        :to="{ name: 'dashboard_my_payments_accounts' }"
        class="w-full md:w-1/2 md:mx-auto"
      >
        <PrimaryButton>Go to Accounts Dashboard</PrimaryButton>
      </router-link>
    </div>
  </div>
</template>
<script>
import { LibraryIcon } from "@heroicons/vue/outline"

export default {
  components: {
    LibraryIcon
  }
}
</script>
